import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    constructor(props) {
        super(props);
        this.rangeLimits = props.rangeLimits;
    }

    handleSliderChange(values) {
        this.props.dispatch(Action.set('RangeOfOutcomes', parseInt(values[0])));
    }

    render() {
        const {rangeOfOutcomes, step = 1, sport} = this.props;

        const currentValue = rangeOfOutcomes.getRangeOfOutcomes(sport);
        const minVal = this.rangeLimits.getMin();
        const maxVal = this.rangeLimits.getMax();

        return (
            <SliderAdapter
                key={`slider-${currentValue}`}
                onChange={::this.handleSliderChange}
                min={minVal}
                max={maxVal}
                defaultValue={currentValue}
                thumb={<div className="circle"></div>}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {rangeOfOutcomes} = state;

    return {
        rangeOfOutcomes,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
